import { Component, inject, Input, Output, EventEmitter } from "@angular/core";
import { SidebarItem } from "../../../services";
import { NgClass } from "@angular/common";
import { Router } from "@angular/router";
import { NgIcon, provideIcons } from "@ng-icons/core";
import { HlmIconDirective } from "@spartan-ng/ui-icon-helm";
import {
  lucideCalendar,
  lucideRoute,
  lucideFileText,
  lucideSpeech,
  lucideStethoscope,
  lucideUsers,
  lucideSettings2,
  lucideMessageCircleQuestion,
  lucideLogOut,
  lucideHouse,
  lucideFolderCog,
  lucideUserRound,
  lucideUpload,
  lucideFile,
  lucideFolder,
} from "@ng-icons/lucide";

@Component({
  selector: "thalea-sidebar-item",
  imports: [NgClass, NgIcon, HlmIconDirective],
  providers: [
    provideIcons({
      lucideHouse,
      lucideCalendar,
      lucideRoute,
      lucideFileText,
      lucideSpeech,
      lucideStethoscope,
      lucideUsers,
      lucideSettings2,
      lucideLogOut,
      lucideMessageCircleQuestion,
      lucideFolderCog,
      lucideUserRound,
      lucideUpload,
      lucideFile,
      lucideFolder,
    }),
  ],
  templateUrl: "./sidebar-item.component.html",
  styleUrl: "./sidebar-item.component.css",
})
export class SidebarItemComponent {
  /** Router instance */
  private readonly _router = inject(Router);

  /** Sidebar item */
  @Input({ required: true }) item!: SidebarItem;

  /** Optional custom click event */
  @Output() itemClick = new EventEmitter<SidebarItem>();

  /**
   * Handles click on the sidebar item
   */
  public onItemClick(): void {
    // If there are listeners for the itemClick event, emit it
    if (this.itemClick.observed) {
      this.itemClick.emit(this.item);
    } else {
      // Otherwise, handle default navigation
      this.navigateToItem();
    }
  }

  /**
   * Navigates to the link of the item
   */
  public navigateToItem(): void {
    if (this.item.link && this.item.link.trim() !== "") {
      this._router.navigate([this.item.link]);
    }
  }
}
